import styled from 'styled-components';

const MarketingHeader = styled.div.withConfig({
    displayName: "styles__MarketingHeader",
    componentId: "sc-3e8aae07-0"
})`
    display: flex;
    align-items: flex-start;
    margin-bottom: ${({ theme  })=>theme.spacers.L};
`;
const Image = styled.img.withConfig({
    displayName: "styles__Image",
    componentId: "sc-3e8aae07-1"
})`
    height: 64px;
    width: 64px;
    display: block;
`;
const LargeImage = styled.img.withConfig({
    displayName: "styles__LargeImage",
    componentId: "sc-3e8aae07-2"
})`
    display: block;
    overflow: hidden;
    border-radius: 4px;
    object-fit: cover;
    width: 100%;
    max-height: 256px;
`;

export { Image, LargeImage, MarketingHeader };
